// import React, { useState, useEffect, useCallback, use } from "react";
// import { Form, InputGroup } from "react-bootstrap";
// import EventTicketCard from "../../components/events/EventTicketCard";
// import { CiSearch } from "react-icons/ci";
// import { api_paths } from "../../config/api.paths";
// import API from "../../config/axios";
// import { useSelector, useDispatch} from "react-redux";
// import { SET_LOADING } from "../../redux/user";

// function EventTickets() {
//   const { user } = useSelector((state) => state.USER_DATA);
//   const [events, setEvents] = useState([]);
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);

//   const [eventType, setEventType] = useState("all");
//   const [search, setSearch] = useState("");

//   // const [isMember, setIsMember] = useState(false);
//   const dispatch = useDispatch();
//   const { loading } = useSelector((state) => state.USER_DATA);

//   const limit = 10;

//   // Detect membership
//   useEffect(() => {
//     // setIsMember(user?.is_membership_active ?? false);
//   }, [user]);

//   // Fetch Events
//   const fetchEventTicket = useCallback(
//     async (pageNo = 1) => {
//       dispatch(SET_LOADING(true));

//       try {
//         const response = await API.get(api_paths.member.EVENTS.ALL_TICKET, {
//           params: {
//             page: pageNo,
//             limit,
//             filter: search,
//             type: eventType,
//             member_id: user?._id,
//           },
//         });
//         const data = response.data?.payload?.result?.data || [];
//         const totalPages =
//           response.data?.payload?.result?.meta?.total_pages || 1;

//         setTotalPages(totalPages);

//         if (pageNo === 1) setEvents(data);
//         else setEvents((prev) => [...prev, ...data]);
//       } catch (err) {
//         console.error("Error fetching events:", err);
//       } finally {
//         dispatch(SET_LOADING(false));
//       }
//     },
//     [eventType, search, user?._id]
//   );

//   // Trigger on eventType or search

//   // Debounce search
//   const handleSearchChange = (e) => {
//     setSearch(e.target.value);
//   };

//   // View More
//   const handleViewMore = () => {
//     if (page < totalPages) {
//       const next = page + 1;
//       setPage(next);
//       fetchEventTicket(next);
//     }
//   };

//   useEffect(() => {
//     setPage(1);
//     fetchEventTicket(1);
//     // eslint-disable-next-line
//   }, [eventType, search, user?._id]);

//   return (
//     <div className="event-tickets-container container mt-4">
//       <h4 className="mb-4 fw-semibold">Event Tickets</h4>

//       {/* Search + Filter */}
//       <div className="d-flex align-items-center gap-3 mb-4">
//         <div className="search-wrapper flex-grow-1">
//           <InputGroup className="rounded-input">
//             <Form.Control
//               className="search-input"
//               type="text"
//               placeholder="Search events by name, description, or location..."
//               value={search}
//               onChange={handleSearchChange}
//             />
//             <InputGroup.Text className="search-icon">
//               <CiSearch size={20} />
//             </InputGroup.Text>
//           </InputGroup>
//         </div>

//         <Form.Select
//           className="filter-dropdown"
//           value={eventType}
//           onChange={(e) => setEventType(e.target.value)}
//         >
//           <option value="all">All Events</option>
//           <option value="upcoming">Upcoming Events</option>
//           <option value="past">Past Events</option>
//         </Form.Select>
//       </div>

//       {/* Events List */}
//       {events.map((event) => (
//         <EventTicketCard key={event.id} event={event} />
//       ))}

//       {!loading && events.length === 0 && (
//         <p className="text-center text-muted mt-4">No events found.</p>
//       )}

//       {/* View more */}
//       {page < totalPages && (
//         <div className="text-center mt-3">
//           <button className="btn btn-primary" onClick={handleViewMore}>
//             Load More
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }

// export default EventTickets;

import React, { useState, useEffect, useCallback } from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import EventTicketCard from "../../components/events/EventTicketCard";
import { CiSearch } from "react-icons/ci";
import { api_paths } from "../../config/api.paths";
import API from "../../config/axios";
import { useSelector, useDispatch } from "react-redux";
import { SET_LOADING } from "../../redux/user";
import SelectField from "../../components/common/SelectField";
import LeftArrow from "../../assets/images/committee/ArrowLeft.svg";
import { useNavigate } from "react-router-dom";

function EventTickets() {
  const dispatch = useDispatch();
  const { user, loading } = useSelector((state) => state.USER_DATA);

  const [events, setEvents] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();

  const [eventType, setEventType] = useState("all");
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const limit = 10;

  const options = [
    { value: "all", label: "All" },
    { value: "upcoming", label: "Upcoming Events" },
    { value: "past", label: "Past Events" },
  ];
  // Debounce search input (wait 500ms before API call)
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  // Fetch Event Tickets
  const fetchEventTicket = useCallback(
    async (pageNo = 1) => {
      if (!user?._id) return; // safety check

      dispatch(SET_LOADING(true));

      try {
        const response = await API.get(api_paths.member.EVENTS.ALL_TICKET, {
          params: {
            page: pageNo,
            limit,
            filter: debouncedSearch,
            type: eventType,
          },
        });

        const data = response?.data?.payload?.result?.data || [];

        const normalizedEvents = data.map((item) => ({
          _id: item._id,
          ...item.event_details,
          ticketsCount: item.event_tickets?.length || 0,
          tickets: item.event_tickets || [],
        }));

        const total = response?.data?.payload?.result?.meta?.total_pages || 1;

        setTotalPages(total);

        if (pageNo === 1) setEvents(normalizedEvents);
        else setEvents((prev) => [...prev, ...normalizedEvents]);
      } catch (err) {
        console.error("Error fetching events:", err);
      } finally {
        dispatch(SET_LOADING(false));
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [eventType, debouncedSearch, user?._id]
  );

  // Load More
  const handleViewMore = () => {
    if (page < totalPages) {
      const next = page + 1;
      setPage(next);
      fetchEventTicket(next);
    }
  };

  // Initial + Filters + Search change

  useEffect(() => {
    setPage(1);
    fetchEventTicket(1);
  }, [eventType, debouncedSearch, user?._id, fetchEventTicket]);

  return (
    <div className="event-tickets-container container mt-4">
      {/* <div>
        <img
          onClick={() => navigate(-1)}
          className="cursor-pointer"
          src={LeftArrow}
          alt="back"
        />
        <h1 className="text-main fw-semibold f-26 mb-4">Event Tickets</h1>
      </div> */}

      <div className="d-flex mb-4">
        <img
          className="cursor-pointer"
          src={LeftArrow}
          alt="back-arrow"
          onClick={() => {
            navigate(-1);
          }}
        />
        <h1 className="mb-0 fw-bold text-main f-20 ms-3">Event Tickets</h1>
      </div>

      {/* Search + Filter */}
      {/* <div className="d-flex align-items-center gap-3 mb-4">
        <div className="search-wrapper flex-grow-1">
          <InputGroup className="rounded-input">
            <Form.Control
              className="search-input"
              type="text"
              placeholder="Search events by name, description, or location..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <InputGroup.Text className="search-icon">
              <CiSearch size={20} />
            </InputGroup.Text>
          </InputGroup>
        </div>

        <Form.Select
          className="filter-dropdown"
          value={eventType}
          onChange={(e) => setEventType(e.target.value)}
        >
          <option value="all">All Events</option>
          <option value="upcoming">Upcoming Events</option>
          <option value="past">Past Events</option>
        </Form.Select>
      </div> */}
      <Form>
        <Row className="mb-4">
          <Col lg={9} md={8}>
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Search events by name, description, or location..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <InputGroup.Text>
                <CiSearch size={20} />
              </InputGroup.Text>
            </InputGroup>
          </Col>

          <Col lg={3} md={4} className="d-flex">
            <div className="w-100 mt-3 mt-md-0">
              <SelectField
                options={options}
                label={null}
                value={options.find((o) => o.value === eventType)}
                onChange={(option) => setEventType(option.value)}
              />
            </div>
          </Col>
        </Row>
      </Form>

      {/* Event List */}
      {events.map((event) => (
        <EventTicketCard key={event?._id} event={event} />
      ))}

      {!loading && events?.length === 0 && (
        <p className="text-center text-muted mt-4">No events found.</p>
      )}

      {/* View More */}
      {page < totalPages && (
        <div className="text-center mt-3">
          <button className="btn btn-primary" onClick={handleViewMore}>
            Load More
          </button>
        </div>
      )}
    </div>
  );
}

export default EventTickets;
